import React, { Component } from 'react';
import Header from './Header'
import Servizi from './Servizi'
import Portfolio from './Portfolio';
import Contact from './Contact';

import 'bootstrap/dist/js/bootstrap.bundle'
import 'jquery.easing/jquery.easing'
import 'jquery.easing/jquery.easing.compatibility'

import '../js/jqBootstrapValidation'
import '../js/contact_me'
import '../js/agency'
import Footer from './Footer';



class Home extends Component {
  render() {
      return (
       <div>

         {/* Header */}
         <header className="masthead">
            <Header />
          </header>
          {/* Services */}
          <section id="services">
           <Servizi />
          </section>
          {/* Portfolio Grid */}
          <section className="bg-light" id="portfolio">
            <Portfolio />
          </section>
          {/* Contact */}
          <section id="contact">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <h2 className="section-heading text-uppercase">Contattami</h2>
                  <h3 className="section-subheading text-muted">per maggiori info e preventivi.</h3>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                 <Contact />
                </div>
              </div>
            </div>
          </section>

          <Footer />

       </div>
      );
    }
  };

  export default Home